import React from 'react';
import { Dialog, DialogTitle, DialogContent, IconButton, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const AnswerAnalysisModal = ({ open, title, text, handleClose, analysis }) => {
    let data = analysis && analysis.sql_query;
    if (analysis && typeof analysis == 'string') {
        let parsedAnalysis = JSON.parse(analysis);
        data = parsedAnalysis.sql_query;
    }

    console.log(analysis?.sql_query, 'analysis', data, typeof data, analysis);

    return (
        <Dialog
            onClose={handleClose}
            aria-labelledby="customized-dialog-title"
            open={open}
            // Apply flexbox styles to center the dialog
            sx={{
                '& .MuiDialog-paper': {
                    // Target the paper component of the dialog
                    width: 'fit-content',
                    maxWidth: '70%',
                },
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            }}
        >
            <DialogTitle sx={{ m: 0, p: 2, fontWeight: 'bold', fontSize: '16px' }} id="customized-dialog-title">
                {title}
            </DialogTitle>
            <IconButton
                aria-label="close"
                onClick={handleClose}
                sx={(theme) => ({
                    position: 'absolute',
                    right: 8,
                    top: 8,
                    color: theme.palette.grey[500],
                })}
            >
                <CloseIcon />
            </IconButton>

            {typeof data === 'object' && Array.isArray(data) ? (
                data.map((item, index) => (
                    <DialogContent key={index} dividers sx={{ background: '#FAFAFA' }}>
                        <Typography variant="subtitle1" gutterBottom fontSize={14}>
                            Query {index + 1}:
                        </Typography>
                        <Typography component="pre" fontSize={14}>
                            {item}
                        </Typography>
                    </DialogContent>
                ))
            ) : (
                <DialogContent dividers sx={{ background: '#FAFAFA', width: 400, height: 400 }}>
                    <Typography gutterBottom fontSize={14}>
                        No Analysis to Display
                    </Typography>
                </DialogContent>
            )}
        </Dialog>
    );
};

export default AnswerAnalysisModal;
